export default "/assets/images/app-update-img-02.png?c77f6cb43475384ec3db14fbae4fb4ae";